import React, { useState, useCallback } from 'react'

import { ShowMoreText, DownArrow, SecondaryFAQContainer, FAQCellContainer } from './secondary-faqs-styles'
import FAQCell from './faq-cell'
import { SecondaryFAQTransport } from '@common/transports/deprecated-home-page-transport'
import { AnalyticsService } from '@src/services'
import { homePageEventCategories } from '@src/services/analytics-service/categories'
import { homePageEventLabels } from '@src/services/analytics-service/labels'

interface Props {
    secondaryFAQs: SecondaryFAQTransport[]
    showMoreText: string
    secondaryFAQVisibleCount: number
}

const SecondaryFAQs: React.FC<Props> = ({ secondaryFAQs, showMoreText, secondaryFAQVisibleCount }) => {
    const [isShowMore, setShowMore] = useState(false)

    const toggleShowMore = useCallback(() => {
        if (!isShowMore) {
            AnalyticsService.trackClickEvent(
                homePageEventCategories.FAQ_SECTION,
                homePageEventLabels.faqSection.SHOW_MORE_ALL,
            )
        }
        setShowMore(!isShowMore)
    }, [setShowMore, isShowMore])

    return (
        <SecondaryFAQContainer>
            {secondaryFAQs.map((faqCell, id) => (
                <FAQCellContainer key={faqCell.title} isVisible={id < secondaryFAQVisibleCount || isShowMore}>
                    <FAQCell title={faqCell.title} description={faqCell.description} />
                </FAQCellContainer>
            ))}
            {!isShowMore && (
                <ShowMoreText onClick={toggleShowMore}>
                    {showMoreText}&nbsp;
                    <DownArrow alt="Down Arrow" />
                </ShowMoreText>
            )}
        </SecondaryFAQContainer>
    )
}

export default SecondaryFAQs
